@import '~mapbox-gl/dist/mapbox-gl.css';
@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';

/**
 * Mapbox-gl overrides
 */
.mapboxgl-map {
  background: @gray-lighter;
}
